import { render } from "./IntroductionSection.vue?vue&type=template&id=1a5d3d18&scoped=true"
import script from "./IntroductionSection.vue?vue&type=script&lang=js"
export * from "./IntroductionSection.vue?vue&type=script&lang=js"

import "./IntroductionSection.vue?vue&type=style&index=0&id=1a5d3d18&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5d3d18"]])

export default __exports__